import React from "react";
import { IMG } from "@/data/content";

export default function DiversBreak() {
  return (
    <section className="relative w-full overflow-hidden bg-ocean-deep md:hidden" data-testid="divers-break">
      {/* Image at its natural aspect ratio — full screen width, edge to edge */}
      <img
        src={IMG.couple}
        alt="Mergulhador e mergulhadora no fundo do mar"
        className="block h-auto w-full object-cover"
      />

      {/* Top wave — white breaks into the sea */}
      <div className="absolute inset-x-0 top-0 z-10 leading-[0]">
        <svg viewBox="0 0 390 60" preserveAspectRatio="none" className="block h-[44px] w-full">
          <path d="M0,0 L390,0 L390,30 C300,8 260,44 190,30 C130,18 80,50 0,24 Z" fill="#ffffff" />
        </svg>
      </div>

      {/* Bottom wave — sea breaks into white */}
      <div className="absolute inset-x-0 bottom-0 z-10 leading-[0]">
        <svg viewBox="0 0 390 70" preserveAspectRatio="none" className="block h-[44px] w-full">
          <path d="M0,44 C100,80 160,24 230,32 C300,40 340,64 390,42 L390,70 L0,70 Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
}
